module.exports = __webpack_public_path__ + "static/Manrope-Medium-6196e0dab83345b15290ee22620358c1.ttf";